import React from 'react';
import GameHeader from './game-header';
import { global_var } from '../../services/cs-lab-config';

const GeekyBirdGameProgrammable = () => {

  document.title = "CS Lab | Geeky Bird Programmable";

  return (
    <div className="container-fluid p-0">
      <div className="row mt-1">
        <div className="col">
          <GameHeader headerName="Geeky Bird Game Programmable" />
          <iframe
            id="GeekyBirdProgIframe"
            src={global_var.GBIRD_P_ENDPOINT} // Use GBIRD_URL from the global_var object
            title="GeekyBirdGameProgrammable"
            //css code set the iframe window
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default GeekyBirdGameProgrammable;
